import { useState } from 'react';

import { IconCheckCircleFilled } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './PennyTransferAction.messages';
import styles from './PennyTransferAction.module.css';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';
import { PennyTransferModal } from './pennyTransferModal/PennyTransferModal';

export const PennyTransferAction = ({
    status,
    triggerRefetchFundingRequirements
}: {
    status: TFundingRequirementsSteps['0']['status'];
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
        triggerRefetchFundingRequirements();
    };

    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    status === 'COMPLETED' ? (
                        <div className={styles.actionIcon}>
                            <IconCheckCircleFilled
                                height="24"
                                width="24"
                                fill="rgba(0, 77, 51, 1)"
                                xlinkTitle="checked"
                            />
                        </div>
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <FormattedMessage {...messages.action} />
                        </Button>
                    )
                }
            />
            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <PennyTransferModal />
            </Modal>
        </>
    );
};
